import ApiService from "services/ApiService";
import { errorHandler } from "utils/errorHandler";

const SingleJourneyService = {
    changeJourneySteps: async function ({journeyId, steps}) {
        const endpoint = `/journeys/${journeyId}`;
        return await ApiService.put(endpoint, { steps });
    },
    deleteJourneyStep: async function ({journeyId, stepId}) {
        const endpoint = `/journeys/${journeyId}/steps?stepId=${stepId}`;
        return await ApiService.delete(endpoint);
    },
    createGroup: async function ({ journeyId, stepIds, label, description }) {
        const endpoint = `/journeys/${journeyId}/group`;
         try{
           return await ApiService.post(endpoint, { stepIds, label, description });
        }
        catch(error) {
            errorHandler(error?.response?.data);
            throw new Error(error);
        }
    },
};

export default SingleJourneyService;
